export default {
  methods: {
    toHelp() {
      this.$router.push({ name: "HelpForgotPassword" });
    },
    toEmail() {
      this.$router.push({ name: "EmailForgotPassword" });
    },
    toManual() {
      this.$router.push({ name: "HelpForgotPasswordOtp", params: { id: 1 } });
    },
  },
};
